import { Reveal, Lines } from "./Reveal";

const PageHero = ({ label, titleLines, intro, dark = false, children }) => (
  <section className={`pt-40 sm:pt-52 pb-16 sm:pb-24 ${dark ? "bg-coal text-paper" : "bg-paper text-coal"}`}>
    <div className="container-ax">
      <Reveal>
        <p className={`label-tech flex items-center gap-3 mb-8 ${dark ? "text-paper/50" : "text-graphite"}`}>
          <span className="inline-block w-2 h-2 rounded-full bg-cobalt" />
          {label}
        </p>
      </Reveal>
      <h1 className="t-h1 max-w-5xl">
        <Lines lines={titleLines} animateOnMount />
      </h1>
      {intro && (
        <Reveal i={2} className="mt-10 max-w-xl">
          <p className={`text-base sm:text-lg leading-relaxed ${dark ? "text-paper/60" : "text-graphite"}`}>{intro}</p>
        </Reveal>
      )}
      {children}
    </div>
  </section>
);

export default PageHero;
